import { render, staticRenderFns } from "./FoldersComponent.vue?vue&type=template&id=b22b70a4&scoped=true"
import script from "./FoldersComponent.vue?vue&type=script&lang=js"
export * from "./FoldersComponent.vue?vue&type=script&lang=js"
import style0 from "./FoldersComponent.vue?vue&type=style&index=0&id=b22b70a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b70a4",
  null
  
)

export default component.exports